module.exports = __webpack_public_path__ + "img/stop.5cfe9cc7.png";